<template>
    <section class="tw:grid! tw:grid-cols-6 quiz-builder quiz-builder-modal">
        <aside class="tw:col-span-2 tw:xl:col-span-1 quiz-builder__menu">
            <quiz-menu :uuid="uuid" />
        </aside>

        <article class="tw:col-span-4 tw:xl:col-span-5 quiz-builder__editor">
            <quiz-editor
                :is-new="isNew"
                :uuid="uuid"
                @close-editor="$emit('close')"
                @created="quizId => $emit('created', quizId)"
            />
        </article>
    </section>
</template>

<script>
import QuizEditor from './quiz-editor/QuizEditor.vue';
import QuizMenu from './quiz-menu/QuizMenu.vue';

export default {
    name: 'QuizBuilder',

    components: { QuizEditor, QuizMenu },

    props: {
        uuid: {
            type: [String, Number],
            required: true,
        },

        isNew: {
            type: Boolean,
            required: false,
        },
    },

    emits: ['close', 'created'],
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.quiz-builder {
    margin: 0 !important;
    min-height: 100vh;
    min-width: 80dvw;

    &__menu {
        background: var(--p-content-background);
        padding: $size-4 $size-3 !important;

        @include until($tablet) {
            padding: $size-10 $size-7 !important;
        }
    }

    &__editor,
    &__tabs {
        background-color: var(--p-content-background);
    }

    &__editor {
        //padding: 0 $size-5 $size-4 $size-5 !important;
        padding: $main-padding !important;

        @include until($tablet) {
            padding: $size-4 $size-7 0 !important;
        }
    }

    &__tabs > nav {
        overflow: visible;

        // Fixes tab underline issue
        & > ul > li {
            margin-bottom: -2px !important;
        }
    }
}
</style>
